import { CHIP_SIZES } from "@widgets/datadisplay/index.jsx";

export const DROPDOWN_SIZES = {
  SMALL_DEPRECATED: "smallDeprecated",
  SMALLPLUS_DEPRECATED: "smallplusDeprecated",
  BASE: "base",
  MEDIUM: "medium",
  SMALL: "small"
};

export const DROPDOWN_TYPE = {
  NORMAL: "normal",
  MINIMAL: "minimal"
};

export const GROUP_TYPE = {
  TITLE_DIVIDER: "title-divider",
  DIVIDER: "divider",
  TITLE: "title"
};

export const DROPDOWN_CHIP_SIZE_MAPPING = {
  [DROPDOWN_SIZES.BASE]: CHIP_SIZES.MEDIUM,
  [DROPDOWN_SIZES.SMALL_DEPRECATED]: CHIP_SIZES.MEDIUM,
  [DROPDOWN_SIZES.SMALLPLUS_DEPRECATED]: CHIP_SIZES.MEDIUM,
  [DROPDOWN_SIZES.MEDIUM]: CHIP_SIZES.TINY,
  [DROPDOWN_SIZES.SMALL]: CHIP_SIZES.TINY
};

export const DROPDOWN_POSITION = {
  TOP: "topCenter",
  TOP_LEFT: "topLeft",
  TOP_RIGHT: "topRight",
  BOTTOM: "bottomCenter",
  BOTTOM_LEFT: "bottomLeft",
  BOTTOM_RIGHT: "bottomRight",
  TOP_LEFT_OVER: "topLeftOver",
  TOP_RIGHT_OVER: "topRightOver",
  BOTTOM_LEFT_OVER: "bottomLeftOver",
  BOTTOM_RIGHT_OVER: "bottomRightOver"
};

export const AUTO_ADJUST_OVERFLOW = {
  adjustX: 1,
  adjustY: 1
};

export const TARGET_OFFSET = [0, 0];

export const POPUP_ALIGNS = {
  topLeft: {
    points: ["bl", "tl"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, -4],
    TARGET_OFFSET
  },
  topCenter: {
    points: ["bc", "tc"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, -4],
    TARGET_OFFSET
  },
  topRight: {
    points: ["br", "tr"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, -4],
    TARGET_OFFSET
  },
  topLeftOver: {
    points: ["bl", "bl"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, 0],
    TARGET_OFFSET
  },
  topRightOver: {
    points: ["br", "br"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, 0],
    TARGET_OFFSET
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, 0],
    TARGET_OFFSET
  },
  bottomCenter: {
    points: ["tc", "bc"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, 4],
    TARGET_OFFSET
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, 4],
    TARGET_OFFSET
  },
  bottomLeftOver: {
    points: ["tl", "tl"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, 0],
    TARGET_OFFSET
  },
  bottomRightOver: {
    points: ["tr", "tr"],
    overflow: AUTO_ADJUST_OVERFLOW,
    offset: [0, 0],
    TARGET_OFFSET
  }
};
